module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-3-f0dc7b6974adaacfeba63a436457e955.svg";